import ColorSwatches from './ColorSwatches'

export default ColorSwatches
